<img *ngIf="file" class="image" [class.fit-width]="fitMode === 'fitWidth' || fitMode === 'fitBoth'"
     [class.fit-height]="fitMode === 'fitHeight' || fitMode === 'fitBoth'"
     [ngStyle]="{'border-radius': borderRadius}" [class.max-width]="fitMode === 'maxWidth' || fitMode === 'maxBoth'"
     [class.max-height]="fitMode === 'maxHeight' || fitMode === 'maxBoth'" [src]="imageUrl" [alt]="file.altTitle"
     (load)="updateImageUrl()">
